<template>
  <div id="formCom" class="formCom" :style="{ top: top || 0 }">
    <div class="form">
      <button class="close" @click="closeModal">
        <CloseIcone></CloseIcone>
      </button>
      <Title :title="titles[step]" :activeStep="step"></Title>
      <ActivateKir @nextStep="nextStep" @kitId="kitId" v-show="step === 0" ></ActivateKir>                                                                                                                 
      <SimplingDetails
        @prevStep="prevStep"
        @nextStep="nextStep"
        v-show="step === 1"
        :kitsId="kit_id"
        @closeModal="closeModal"
      ></SimplingDetails>
      <Review
        v-if="step === 2"
        @nextStep="nextStep"
        @prevStep="prevStep"
      ></Review>    
      <Instructions
        v-if="step === 3"
        @nextStep="nextStep"
        @prevStep="prevStep"
      ></Instructions>
      <ShareReport
        v-if="step === 4"
        @nextStep="nextStep"
        @prevStep="prevStep"
        @reRenderHome="reRenderHome"
      ></ShareReport>
      <FinalStep
        v-if="step === 5"
        @nextStep="nextStep"
        @prevStep="prevStep"
        @reRenderHome="reRenderHome"
      ></FinalStep>
    </div>
  </div>
</template>

<script>
import ActivateKir from "./ActiveteNewKit/ActivateKit";
import SimplingDetails from "./ActiveteNewKit/SimplingDetails";                                                                
import Review from "../registration/steps/Review";                                                               
import Instructions from "../registration/steps/Instructions";                                                               
import FinalStep from "../registration/steps/FinalStep";  
import ShareReport from "../registration/steps/ShareReport";                                                              
import Title from "./ActiveteNewKit/Title";
import CloseIcone from "../../images/shared/cancel";

export default {
  name: "ActivateNewKit",
  props: ["newKitModal", "top"],
  data() {
    return {
      step: this.newKitModal.step,
      kit_id:{enterKit:this.newKitModal.kit_id,verifyKit:this.newKitModal.kit_id},
      titles: ["Activate Your Kit", "Sampling Details", "Review & Confirm", "Next Steps"],
    };
  },
  methods: {
    nextStep(e) {
      this.step += e;
    },
    prevStep(e) {
      this.step -= e;
    },
    reRenderHome() {
      this.$emit("reRenderHome");
    },
    closeModal() {
      this.$emit("resetModal", false);
    },
    kitId(e) {
      this.kit_id = e;
    }
  },
  components: {
    Title,
    SimplingDetails,
    Review,
    Instructions,
    FinalStep,
    ActivateKir,
    ShareReport,
    CloseIcone
  },
  updated() {
  this.$nextTick(function () {
    this.$emit("changeHeight", document.getElementById('formCom').clientHeight);
  })
}

};
</script>

<style scoped lang="scss">
@import "../../styles/colors";
.formCom {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  z-index: 99;
}
.form {
  padding: 36px 80px 40px 80px;
  box-shadow: 0 3px 15px 10px $boxShadow !important;
  border-radius: 15px;
  font-family: TTNormsMedium, sans-serif;
  background-color: $white;
  max-width: 550px;
  width: 100%;
  position: relative;
}
.close {
  position: absolute;
  right: 15px;
  top: 15px;
  border: 1px solid transparent;
  cursor: pointer;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
}
@media (max-width: 1024px) {
  .formCom {
    align-items: flex-start;
  }
  .form {
    margin: 50px 0 0 0;
    padding: 20px;
  }
}
@media (max-width: 568px) {
  .form {
    padding: 20px;
  }
}
</style>
